import { Box, Button, Grid, Typography } from "@mui/material";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import logo from "../../images/willsoar.svg";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import { useForm } from "react-hook-form";
import { callAPI, Method } from "../../commonFunctions/CommonFunctions";
import { useState } from "react";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { Helmet } from "react-helmet";

export default function ResetPassword() {
  const { control, handleSubmit } = useForm();
  const { showMessage } = useSnackbar();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [loading, setLoading] = useState(false);

  const handleSentResetReq = async (data: any) => {
    try {
      setLoading(true);

      const payload = {
        token,
        password: data.newPassword
      };

      const response: any = await callAPI(
        "auth/reset/password",
        Method.POST,
        payload
      );

      if (response?.message) {
        showMessage(response.message, "success");
        navigate("/login");
      }
    } catch (error: any) {
       console.error("Failed to reset password", error);
        if (error.message === 'GlobalHandledError') return;
         showMessage(
        error?.response?.data.message || "An unexpected error occurred",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Reset Password | Willsoar Technologies</title>
        <meta
          name="description"
          content="Log in to access your estimates, invoices, clients, and more with our powerful estimation tool."
        />
      </Helmet>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          minHeight: "50vh",
          textAlign: "center"
        }}
      >
        {/* Logo Header */}
        <Grid item xs={12} mb={-3}>
          <Box
            sx={{
              mb: 2,
              display: "inline-block",
              px: 4,
              py: 1,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10
            }}
          >
            <img
              src={logo}
              alt="Willsoar Logo"
              style={{
                height: 50,
                objectFit: "contain"
              }}
            />
          </Box>
        </Grid>

        {/* Reset Form Box */}
        <Grid item xs={11} sm={8} md={4}>
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: 2,
              padding: 4,
              boxShadow: "0px 4px 15px rgba(0,0,0,0.1)"
            }}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              textAlign="left"
              mb={2}
              sx={{ color: "#2c3e50" }}
            >
              Reset Password
            </Typography>

            <form onSubmit={handleSubmit(handleSentResetReq)}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <WSTextField
                    control={control}
                    id="newPassword"
                    rules={{ required: "please enter your new password!" }}
                    name="newPassword"
                    label="Enter new password *"
                    type={TextType.Password}
                    sx={{
                      marginBottom: 1,
                      backgroundColor: "rgba(0,0,0,.05)",
                      boxShadow: "none",
                      border: 0,
                      color: "#444",
                      fontSize: 16,
                      transition: "width 0.25s"
                    }}
                  />
                </Grid>

                {/* <Grid item xs={12}>
                <WSTextField
                  control={control}
                  id="confirmPassword"
                  {...register("confirmPassword", {
                    required: true,
                    validate: (value: any) => {
                      const password = watch("newPassword");
                      return value === password || "Passwords do not match";
                    }
                  })}
                  name="confirmPassword"
                  label="Confirm new password *"
                  type={TextType.Password}
                  sx={{
                    marginBottom: 1,
                    backgroundColor: "rgba(0,0,0,.05)",
                    boxShadow: "none",
                    border: 0,
                    color: "#444",
                    fontSize: 16,
                    transition: "width 0.25s"
                  }}
                />
              </Grid> */}

                <Button
                  fullWidth
                  size="small"
                  variant="contained"
                  sx={{
                    mt: 2,
                    backgroundColor: "#fe6a2c",
                    textTransform: "none",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#e55d1e"
                    }
                  }}
                  disabled={loading}
                >
                  {loading ? "please wait..." : "Reset Password"}
                </Button>
              </Grid>
            </form>
          </Box>

          {/* <Typography
          variant="body2"
          sx={{ mt: 2, textAlign: "center", color: "#34495e" }}
        >
          Go back to{" "}
          <Link
            to="/login"
            style={{ color: "#fe6a2c", textDecoration: "none" }}
          >
            Login
          </Link>
        </Typography> */}
        </Grid>
      </Grid>
    </>
  );
}
